export const supplierCategoryResourceType = 'supplier_category';

export const supplierCategoriesResourcePath =
  '/me/customer/supplier_categories';
